<template>
  <p v-if="remaining">
    {{ $t('reservedFor') }} <strong>{{ remaining }}</strong> min.
  </p>
</template>

<script>
import eventBus from '../eventBus.js'

import { RESERVATION_ABOUT_TO_EXPIRE } from '../settings.js'

export default {
  name: 'CCartTimer',

  data () {
    return {
      remaining: null,
      interval: null,
      isAboutToExpire: false
    }
  },

  computed: {
    validUntil () {
      return this.$store.state.cart.valid_until
    }
  },

  watch: {
    validUntil () {
      this.stop()
      this.start()
    }
  },

  mounted () {
    this.start()
  },

  beforeDestroy () {
    this.stop()
  },

  methods: {
    start () {
      if (!this.validUntil) {
        return
      }

      this.setRemaining()
      this.interval = setInterval(() => this.setRemaining(), 1000)
    },
    stop () {
      clearInterval(this.interval)
      this.remaining = null
      this.isAboutToExpire = false
    },
    setRemaining () {
      const validUntil = new Date(this.validUntil)
      const now = new Date()

      const remainingMS = Math.max(validUntil - now, 0)
      const remainingDate = new Date(remainingMS)
      const remainingFormat = { minute: '2-digit', second: '2-digit' }

      this.remaining = remainingDate.toLocaleTimeString(this.$i18n.locale, remainingFormat)

      if (!this.isAboutToExpire && remainingMS <= RESERVATION_ABOUT_TO_EXPIRE) {
        this.isAboutToExpire = true

        eventBus.emit('showMessage', {
          title: this.$t('aboutToExpire.title'),
          message: this.$t('aboutToExpire.message'),
          showOk: false,
          buttons: [
            {
              label: this.$t('aboutToExpire.button'),
              color: 'primary',
              callback: () => this.$store.dispatch('resetCartTimer')
            }
          ]
        })
      }

      if (!remainingMS) {
        this.stop()
        this.$store.dispatch('getCart', { dontResetSelection: true })

        const redirect = () => {
          const name = `booking-${this.$i18n.locale}`

          if (this.$route.name === name) {
            return
          }

          this.$router.push({ name })
        }

        eventBus.emit('showMessage', {
          title: this.$t('expired.title'),
          message: this.$t('expired.message'),
          showOk: false,
          buttons: [
            {
              label: this.$t('expired.button'),
              color: 'primary',
              callback: redirect
            }
          ]
        })
      }
    }
  }
}
</script>

<i18n locale="en">
{
  "reservedFor": "Tickets reserved for",
  "aboutToExpire": {
    "title": "Reservation is about to expire",
    "message": "Are you still there?",
    "button": "Extend reservation"
  },
  "expired": {
    "title": "Reservation expired",
    "message": "The reservation for your selected tickets expired.",
    "button": "Select new tickets"
  }
}
</i18n>

<i18n locale="de">
{
  "reservedFor": "Karten reserviert für",
  "aboutToExpire": {
    "title": "Reservierung läuft bald ab",
    "message": "Sind Sie noch da?",
    "button": "Reservierung verlängern"
  },
  "expired": {
    "title": "Reservierung abgelaufen",
    "message": "Die Reservierung Ihrer Karten ist abgelaufen.",
    "button": "Neue Karten wählen"
  }
}
</i18n>
